export default __webpack_public_path__ + "static/media/albaraka.ed463387.png";